export interface SideNavCategory<T = unknown> {
  name: string;
  preLocalizedName?: string;
  key: string;
  items?: Array<SideNavCategory>;
  parent?: SideNavCategory;
  tag?: T;
  typeName?: string;
  formattedSearchText?: string;
  customSuffixMessage?: string;
}

export enum SideNavCategoryTypeName {
  StandardReport = 'StandardReport',
  SavedReport = 'SavedReport',
  RecentReport = 'RecentReport',
  Searchable = 'Searchable',
  SharedReport = 'SharedReport',
}
export interface SideNavItemSelectEvent<T = unknown> extends React.UIEvent {
  category: SideNavCategory<T>;
}

export type SideNavColorScheme = 'dark' | 'blue';

export interface SideNavColorSchemeProps {
  colorScheme?: SideNavColorScheme;
}

export type SideNavColorSchemeIndex = {
  [k in SideNavColorScheme]?: string;
};

export { default as SideNav } from './SideNav';
